import React from 'react'

export const ErrorIconSvg = ({ width = '128', height = '124' }) => (
  <svg width={width} height={height} viewBox="0 0 128 124">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#E06065"
        d="M32.651 8L1 61.833l31.651 53.833h63.302l31.652-53.833L95.953 8z"
      />
      <g stroke="#FFF" strokeWidth="12.902">
        <path d="M41.755 38.661l45.094 45.42M86.85 38.661l-45.095 45.42" />
      </g>
      <path
        fill="#EA868A"
        d="M50.049 24.672s-2.824-7.744 12.597-9.68c15.42-1.937 18.027 5.378 18.027 5.378s1.303 3.226-2.607 7.099l-10.208 10.11s-2.606 2.367-6.08-.215C58.301 34.783 50.7 27.9 50.047 24.672M28.818 51.677l8.238 7.03s2.747 2.076.802 4.726c-1.946 2.651-7.438 6.916-7.438 6.916s-3.776 1.152-7.667-2.767c-3.89-3.918-5.378-7.837-2.86-11.295 2.517-3.458 6.064-6.223 8.925-4.61"
      />
    </g>
  </svg>
)
